window.update_pie_chart = function (date_id, chart_id) {
    var date = $(date_id).val().split('-')
    $.ajax({
        type: "POST",
        url: "/admin/update_data",
        data: {
            "month": date[1],
            "year" : date[0]
        },
        dataType: "json",
        success: function (data) {
            var chart = Chartkick.charts[chart_id];
            chart.updateData(data);
        }
    })
}

window.update_bar_chart = function (date_id, chart_id) {
    var date = $(date_id).val().split('-')
    $.ajax({
        type: "get",
        url: "/chart/room_ocupacity_data",
        data: {
            "requested_month": date[1],
            "year": date[0]
        },
        dataType: "json",
        success: function (data) {
            var chart = Chartkick.charts[chart_id];
            chart.updateData(data);
        }
    })
}